// extracted by mini-css-extract-plugin
export var linkText = "_qg-0";